import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { LanguageSelector } from '@/components/LanguageSelector';
import { Label } from '@/components/ui/Label';

export function Language() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Settings.components.General.components.LanguageSelector',
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Globe className="h-5 w-5" />
        <Label htmlFor="language" className="text-base font-medium">
          {t('title')}
        </Label>
      </div>

      <div className="space-y-2">
        <LanguageSelector />

        <p className="text-sm text-muted-foreground">
          {t('chooseLanguageDescription')}
        </p>
      </div>
    </div>
  );
}
